// @ts-nocheck
import { StyledButton } from "@insite/mobius/Clickable";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusUpdateStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const menu: Styleguide["menu"] = {
    defaultProps: {
        cssOverrides: {
            menu: css`
                z-index: ${x => x.theme.zIndex.menu};
                box-shadow: ${x => x.theme.shadows.e80};
                background-color: ${getColor("common.background")};
                font-size: ${x => x.theme.design.typography.size.small};
                line-height: ${x => x.theme.design.typography.lineHeight.semi};
            `,
            menuItem: css`
                ${StyledButton} {
                    ${linkStyles("text.linkAlt", "text.linkAltHover", false, true)}
                    ${focusUpdateStyles(true)}
                    min-height: unset;

                    &:hover {
                        background-color: transparent;
                    }
                }

                ${TypographyStyle} {
                    color: inherit;
                }
            `,
        },
        moreIconProps: {
            src: ChevronRight,
            color: "primary",
        },
    },
};

export default menu;
